<div class="unternehmen-administration--wrapper">
    <section class="unternehmen-administration--left">
        <img
            src="/assets/images/svgs/nerd.svg"
            class="unternehmen-administration--left--nerd-svg"
            alt="Menüpunkt Postkorb"
        />
    </section>

    <div>
        <section class="unternehmen-administration--right--top-section">
            <h1 style="font-weight: 700; margin-bottom: 1rem;">SERVICEPORTAL</h1>
            <p style="margin-bottom: 2rem;">
                Sie sind als Admin für Ihr Unternehmen im Serviceportal registriert.<br />
                Ihnen stehen folgende Funktionen zur Verfügung:
            </p>
        </section>
        <section class="unternehmen-administration--right--bottom-section mt-5">
            <a routerLink="/alle-antraege">
                <mat-card class="unternehmen-administration--right--bottom-section--custom-mat-class"> <p>Anträge stellen und verwalten</p> </mat-card>
            </a>
            <a routerLink="/unternehmensverwaltung/alle-benutzer">
                <mat-card class="unternehmen-administration--right--bottom-section--custom-mat-class"> <p>Alle Benutzer*innen</p> </mat-card>
            </a>
            <a routerLink="/unternehmensverwaltung/unternehmensstammdaten">
                <mat-card class="unternehmen-administration--right--bottom-section--custom-mat-class"> <p>Stammdaten</p> </mat-card>
            </a>
        </section>
    </div>
</div>
